import { render } from "./TaskPopup.vue?vue&type=template&id=1f748eed&scoped=true"
import script from "./TaskPopup.vue?vue&type=script&lang=js"
export * from "./TaskPopup.vue?vue&type=script&lang=js"

import "./TaskPopup.vue?vue&type=style&index=0&id=1f748eed&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f748eed"]])

export default __exports__